import PropTypes from 'prop-types';
import Calendar from 'react-date-picker';
import { DashboardDateField, ExperienceStatus, VpayExperience } from '@vezeeta/vpay-pack';
import { Page, Baseline } from './VpayContent.style';

const renderDateField = props => <DashboardDateField {...props} Calendar={Calendar} />;

export default function VpayContent({
  culture,
  state,
  retry,
  refresh,
  path,
  redirectPath,
  search,
  navigate,
  hrefFor,
  api,
  content,
}) {
  return (
    <Page className="vpay-page" lang={culture.startsWith('ar') ? 'ar' : 'en'}>
      <Baseline />
      <link rel="stylesheet" href="https://fonts.vezeeta.com?family=SourceSansPro,TheSansArabic" />
      {state.loading || state.error ? (
        <ExperienceStatus {...state} retry={retry} content={content.status} />
      ) : (
        <VpayExperience
          path={path}
          redirectPath={redirectPath}
          search={search}
          navigate={navigate}
          hrefFor={hrefFor}
          account={state.account}
          api={api}
          content={content}
          locale={culture.split('-')[0]}
          countryCode={culture.split('-')[1]}
          currency={culture.endsWith('-SA') ? 'SAR' : 'EGP'}
          onAccountChange={refresh}
          allowEmailChange={false}
          renderDateField={renderDateField}
        />
      )}
    </Page>
  );
}

VpayContent.propTypes = {
  culture: PropTypes.string.isRequired,
  state: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    error: PropTypes.instanceOf(Error),
    account: PropTypes.shape({}),
  }).isRequired,
  retry: PropTypes.func.isRequired,
  refresh: PropTypes.func.isRequired,
  path: PropTypes.string.isRequired,
  redirectPath: PropTypes.string.isRequired,
  search: PropTypes.string.isRequired,
  navigate: PropTypes.func.isRequired,
  hrefFor: PropTypes.func.isRequired,
  api: PropTypes.objectOf(PropTypes.func).isRequired,
  content: PropTypes.shape({ status: PropTypes.shape({}).isRequired }).isRequired,
};
